(function() {

    var AudioEngine = window.AudioEngine = function( stateController, settings ) {

        var my = this;

        //
    
        my.settings = settings;

        my.stateController = stateController;
    
        my.settings.useWebAudio = !my.stateController.isIE;

        my.initialized = false;
        my.active = false;
        
        //

        my.samples = [];
        my.blobSetQueue = [];

        //

        my.fade = 1;
    
        //

        window.addEventListener('AUDIOINIT', function(e){

            if (!my.initialized) my.init();

        });

        window.addEventListener('AUDIOSETFADE', function(e){

            if (!my.initialized) my.init();

            my.fade = e.detail.fade;

        });

        window.addEventListener('AUDIOPLAYONCE', function(e){

            if (!my.initialized) my.init();
            
            //

            var sampleBlob = e.detail.blob;

            if (my.samples[sampleBlob]===undefined) {
                my.initSound(sampleBlob,false,true);
            } else {
                my.playOnce(sampleBlob);
            }

        });

        window.addEventListener('AUDIOPLAYLOOP', function(e){

            if (!my.initialized) my.init();

            //

            var sampleBlob = e.detail.blob;

            if (my.samples[sampleBlob]===undefined) {
                my.initSound(sampleBlob,true,true);
            } else {
                my.playLoop(sampleBlob);
            }
            
        });

        window.addEventListener('AUDIOPLAY3DSET', function(e){

            if (!my.initialized) my.init();

            // stop any currenyly playing sounds

            my.stopSounds();

            // this queues a new set of samples so they can all play at eaxactly the same time

            my.audioController = e.detail.audioController;

            var blobSet = e.detail.set;

            for (let index = 0; index < blobSet.length; index++) {

                const sampleBlob = blobSet[index];
                if (my.samples[sampleBlob]===undefined) my.initSound( sampleBlob, true, false, index/blobSet.length*Math.PI*2 );

            }

            my.blobSetQueue.push(blobSet);

        });

        //

        my.initSound = function( sampleBlob, loop, playWhenReady, angle) {

            if (my.settings.useWebAudio) {

                // webaudio

                if (my.samples[sampleBlob]===undefined) {

                    var sampleInfo = {
                        blob: sampleBlob,
                        ready: false,
                        loop: loop,
                        playWhenReady:playWhenReady,
                        angle:angle
                    };
   
                    my.samples.push(sampleInfo);
                    my.samples[sampleBlob] = sampleInfo;

                    //
                    
                    var request = new XMLHttpRequest();
                    request.open('GET', sampleBlob, true);
                    request.responseType = 'arraybuffer';
                    request._sampleInfo = sampleInfo;

                    request.onload = function() {

                        var req = this;

                        my.audioContext.decodeAudioData(this.response, function(buffer) {

                            var thisSampleInfo = req._sampleInfo;

                            thisSampleInfo.buffer = buffer;
                            thisSampleInfo.ready = true;
                            
                            if (playWhenReady&&!loop) my.playOnce(thisSampleInfo.blob);
                            if (playWhenReady&&loop) my.playLoop(thisSampleInfo.blob);

                        }, function(){});

                    };

                    request.send();
    
                }

            } else {

                // ie

                if (my.samples[sampleBlob]===undefined) {

                    var sampleInfo = {
                        blob: sampleBlob,
                        ieSound: new Audio(sampleBlob),
                        ready:true,
                        loop:loop,
                        angle:angle,
                    };

                    my.samples.push(sampleInfo);
                    my.samples[sampleBlob] = sampleInfo;

                    if (playWhenReady&&!loop) my.playOnce(sampleBlob);
                    if (playWhenReady&&loop) my.playLoop(sampleBlob);

                }

            }

        };

        my.playOnce = function(sampleBlob) {

            // not for loops

            console.log("Warning this should not be called");

            var sampleInfo = my.samples[sampleBlob];

            if (my.settings.useWebAudio) {

                var sampleNode = my.audioContext.createBufferSource(); 
                sampleNode.buffer = sampleInfo.buffer;                  
                sampleNode.connect(my.masterVolumeNode);
                sampleNode.loop = false;

                sampleNode.start(0);

            } else {

                var ieSound = sampleInfo.ieSound;
                ieSound.volume = my.stateController.volume*my.fade;
                ieSound.loop = false;
                ieSound.play();

            }

        };

        my.playLoop = function(sampleBlob) {
            
            // for loops

            var sampleInfo = my.samples[sampleBlob];

            if (sampleInfo.playing) return;

            if (my.settings.useWebAudio) {

                var sampleNode = my.audioContext.createBufferSource(); 
                sampleInfo.node = sampleNode;
                sampleNode.buffer = sampleInfo.buffer;         
                sampleNode.connect(my.masterVolumeNode);         
                sampleNode.loop = sampleInfo.loop;

                //

                sampleNode.start(0);

                //
                
                sampleInfo.playing = true;

            } else {
                        
                var ieSound = sampleInfo.ieSound;
                ieSound.volume = my.stateController.volume*my.fade;
                ieSound.loop = true;
                ieSound.play();

                sampleInfo.playing = true;

            }

        };

        my.stopSounds = function() {

            for (let index = 0; index < my.samples.length; index++) {

                var sampleInfo = my.samples[index];

                if (sampleInfo.playing) {

                    if (my.settings.useWebAudio) {

                        sampleInfo.node.stop();
                        sampleInfo.playing = false;

                    } else {
                        
                        sampleInfo.ieSound.pause();
                        sampleInfo.ieSound.currentTime = 0;
                        sampleInfo.playing = false;

                    }

                }

            }

        };
    
        my.init = function() {

            if (my.settings.useWebAudio) {

                window.AudioContext = window.AudioContext||window.webkitAudioContext;
    
                my.audioContext = new AudioContext();
    
                //
    
                my.masterVolumeNode = my.audioContext.createGain();
    
                my.masterVolumeNode.connect(my.audioContext.destination);
    
                my.masterVolumeNode.gain.value = my.stateController.volume;
            
            }

            //

            my.initialized = true;

            my.active = true;

            //

            my.processRunner = window.setInterval(function(){

                if (my.active) my.process();
    
            },1000/10);
            
        };

        my.process = function() {

            var sampleInfo;

            if (my.settings.useWebAudio) {

                // webaudio

                my.masterVolumeNode.gain.value = my.stateController.volume*my.fade;

            } else {

                // ie

                for (let index = 0; index < my.samples.length; index++) {
                    sampleInfo = my.samples[index];
                    if (sampleInfo.playing) {
                        sampleInfo.ieSound.volume = my.stateController.volume*my.fade;
                    }
                }

            }

            // handle any queued sound sets

            if (my.blobSetQueue.length>0) my.processQueue();

        };

        my.processQueue = function() {

            // get first in queue

            var blobSet = my.blobSetQueue[0];

            // check all sounds are ready

            for (let index = 0; index < blobSet.length; index++) {

                const sampleInfo = my.samples[blobSet[index]];

                if (!sampleInfo.ready) {
                    // not ready, exit
                    return;
                }
                
            }

            // play them if they are ready

            for (let index = 0; index < blobSet.length; index++) {
                const sampleInfo = my.samples[blobSet[index]];
                my.playLoop(sampleInfo.blob);
            }

            my.blobSetQueue.shift();

        };

        //
    
        my.dispatchEvent = function( name, eventDetail ) {
        
            if (my.stateController.debugMode) console.log( "EVENT", name, eventDetail );
        
            var thisEvent;
        
            if (my.stateController.isIE) {
        
                // IE11 doesn't support native customEvent....
                thisEvent = document.createEvent("CustomEvent");
                thisEvent.initCustomEvent(name, true, true, eventDetail);
        
            } else {
        
                thisEvent = new CustomEvent(name, { "detail": eventDetail });
        
            }
        
            my.stateController.eventDispatcher.dispatchEvent( thisEvent );
        
        };

    };

    //

    Math.fract = function(n) { return n-Math.floor(n); };

	Math.clamp = function(n, min, max) { return Math.min(Math.max(n, min), max); };

	Math.wrap = function(x,n) { return (x % n + n) % n; };
  
  })();
define("spin/audio-engine-low", function(){});

